var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"justify":"space-around","align":"center","no-gutters":""}},[_c('inspection-pdf',{attrs:{"inspection-id":_vm.itemIsStock ? undefined : _vm.item.id,"stock-id":_vm.itemIsStock ? _vm.item.id : undefined,"type":"fab","show-prices":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }